import type { SuperAdminDueTodayRequest } from "@nlc/shared-types";

import { whitelabelRowClassName } from "@/features/requests/constants/accountTags";

import type { TableConfig } from "../../../types/tables";

import { TABLE_LAYOUT_PRESETS } from "../../constants/columnWidths";
import {
  inlineAssigneeCell,
  inlineComplexityCell,
  inlineDueDateCell,
  inlineStatusCell,
} from "../../helpers/cellRenderers";
import {
  accountCellWithSlotTooltip,
  dateCell,
  nameCell,
  requestDesignTypeCell,
} from "../../helpers/commonCells";

// Due Today Tab Configuration for SuperAdmin
// Columns: Name, Account, Assignee, Due, Status, Level, Created date, Request/Design type
export const dueTodayTableConfig: TableConfig<SuperAdminDueTodayRequest> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.name,
    },
    {
      accessor: "account",
      cellRenderer: accountCellWithSlotTooltip,
      header: "Account",
      key: "account",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.account,
    },
    {
      accessor: "assignee",
      cellRenderer: inlineAssigneeCell, // Inline editable
      header: "Assignee",
      key: "assignee",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.assignee,
    },
    {
      accessor: "dueDate",
      cellRenderer: inlineDueDateCell,
      header: "Due",
      key: "dueDate",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.dueDate,
    },
    {
      accessor: "status",
      cellRenderer: inlineStatusCell, // Inline editable
      header: "Status",
      key: "status",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.status,
    },
    {
      accessor: "complexity",
      cellRenderer: inlineComplexityCell, // Inline editable
      header: "Level",
      key: "complexity",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.complexity,
    },
    {
      accessor: "createdAt",
      cellRenderer: dateCell,
      header: "Created date",
      key: "createdAt",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.createdAt,
    },
    {
      accessor: "designType",
      cellRenderer: requestDesignTypeCell,
      header: "Request/Design type",
      key: "designType",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.requestType,
    },
  ],
  defaultSort: {
    column: "dueDate",
    direction: "asc", // Soonest due first
  },
  enableSorting: true,
  getRowClassName: whitelabelRowClassName,
  id: "superadmin-due-today-requests",
  title: "Due Today",
};
